import api from "./api";

export const WA_FIRMA_FIELDS = [
  { key: "nome", label: "Nome studio" },
  { key: "indirizzo", label: "Indirizzo" },
  { key: "telefono", label: "Telefono" },
  { key: "email", label: "E-mail" },
  { key: "pec", label: "PEC" },
  { key: "sito", label: "Sito web" },
];

// Blocco "Firma studio" con i soli dati selezionati dal titolare (vuoto se nessuno).
export const buildWaStudioBlock = (data) => {
  const s = data?.settings || {};
  const sel = Array.isArray(s.wa_firma_fields) ? s.wa_firma_fields : [];
  const v = (x) => String(x || "").trim();
  const cityLine = [v(s.cap), v(s.citta)].filter(Boolean).join(" ") + (v(s.provincia) ? ` (${v(s.provincia)})` : "");
  const val = {
    nome: v(data?.studio_name || s.studio_name),
    indirizzo: [v(s.indirizzo), v(cityLine)].filter(Boolean).join(", "),
    telefono: v(s.telefono || s.cellulare) && `Tel. ${v(s.telefono || s.cellulare)}`,
    email: v(s.email_contatto) && `E-mail: ${v(s.email_contatto)}`,
    pec: v(s.pec) && `PEC: ${v(s.pec)}`,
    sito: v(s.sito_web),
  };
  return WA_FIRMA_FIELDS.filter((f) => sel.includes(f.key) && val[f.key]).map((f) => val[f.key]).join("\n");
};

let lastStudioBlock = "";
export const getLastWaStudioBlock = () => lastStudioBlock;

// Punto unico di apertura WhatsApp: recupera firma studio + firma pubblicitaria e le accoda al testo prima di costruire il link wa.me.
export async function fetchWaSignature() {
  try {
    const { data } = await api.get("/studio/me");
    const s = data?.wa_signature;
    const ad = s?.enabled ? String(s.text || "").trim() : "";
    lastStudioBlock = buildWaStudioBlock(data);
    return [lastStudioBlock, ad].filter(Boolean).join("\n\n");
  } catch (e) {
    console.warn("[WhatsApp] impossibile leggere la firma pubblicitaria dallo studio", e);
    return "";
  }
}

export const appendWaSignature = (text, sig) => {
  const body = (text || "").trim();
  if (!sig || body.includes(sig)) return body;
  return body ? `${body}\n\n${sig}` : sig;
};

// Apre la finestra subito (gesto utente) e la reindirizza a wa.me con testo + firma. Restituisce il testo finale.
export async function openWhatsApp(waNumber, text = "") {
  const win = window.open("", "_blank");
  const sig = await fetchWaSignature();
  const finalText = appendWaSignature(text, sig);
  console.log("[WhatsApp] firma pubblicitaria al momento dell'invio:", { firma: sig || null, aggiunta: finalText !== (text || "").trim(), testoFinale: finalText });
  const url = `https://wa.me/${waNumber}${finalText ? `?text=${encodeURIComponent(finalText)}` : ""}`;
  if (win) { win.opener = null; win.location.href = url; }
  else window.open(url, "_blank", "noopener,noreferrer");
  return finalText;
}
